/* eslint-disable */
// src/layouts/visitMachine/strategies/FichaStrategy.js

/* File: src/layouts/visitMachine/strategies/<tipo>Strategy.js
 * Estrategia concreta (Tragamoneda/Pool-Tejo/Rockola/Peluchera).
 * Implementa calculate(...) para producir moneyIn/Out, netos y collected.
 * No toca la UI; sólo devuelve números/flags que luego muestra el builder.
 */

import { calculateFormula } from "layouts/visitMachine/strategies/calculateFormula";
import { resolveProfitPercentage } from "./resolveProfitPercentage";

export class FichaStrategy {
  calculate(machine, userInputs, visitMachineDetails, profitPercentages, isEditMode, prevRecords) {
    const keyId = Number(machine?.LocalMachineId ?? machine?.Id);

    const original = isEditMode
      ? prevRecords.find((r) => Number(r.LocalMachineId) === keyId)
      : null;
      
    const rawActualIn = userInputs[keyId]?.CreditsIn;
    const hasActualIn = rawActualIn !== null && rawActualIn !== undefined && rawActualIn !== "";
    const actualIn = hasActualIn ? Number(rawActualIn) : null;

    const formula =
   machine?.Formula
   ?? (machine?.FormulaType != null
       ? { Type: machine.FormulaType, Value: Number(machine.FormulaValue ?? 0) }
       : null);

    const moneyCollected = hasActualIn
      ? (formula ? calculateFormula(actualIn, formula) : actualIn)
      : null;

    const profit = resolveProfitPercentage(machine, profitPercentages, isEditMode);

    const clientAmount = moneyCollected != null
      ? (moneyCollected * (profit.ClientPercentage || 0)) / 100
      : null;
    const ownerAmount  = moneyCollected != null
      ? (moneyCollected * (profit.OwnerPercentage || 0)) / 100
      : null;

    const localMachineProfitPercentageId = profit.Id ?? null;
    
    return {
      ...machine,
      LastVisitMachineId: original?.LastVisitMachineId ?? machine?.LastVisitMachineId ?? null,
      LocalMachineId: original?.LocalMachineId || keyId,
      MachineTypeId: machine.MachineType?.Id ?? machine?.MachineTypeId ?? null,
      FormulaId: machine.Formula?.Id ?? machine?.FormulaId ?? null,
      actualCreditsIn: actualIn,
      netCreditsIn: null,
      netCreditsOut: null,
      creditsCollected: null,
      moneyIn: null,
      moneyOut: null,
      moneyCollected,
      clientAmount,
      ownerAmount,
      note: userInputs[keyId]?.Note || "",
      LocalMachineProfitPercentageId: localMachineProfitPercentageId,
    };
  }
}
